import angular, { ILogService, ITimeoutService } from 'angular'
import { join, split } from 'lodash'
import { AccesoDatos } from 'src/_candidato/comun/services/acceso-datos'
import { TiposDocStore } from 'src/_candidato/data/tiposStore'
import { NotificacionService } from 'src/_panel/module/uni-base/services/NotifService'
import { IEstadoCvStore, IModelNotificacionDoc } from 'src/model/candidato-api'

import './panel-doc-notifications.scss'

class PanelDocNotificationsComponentCtrl {
  $loading = false
  $ready = false

  reglas: ReglaNotifDoc[]
  estados: IEstadoCvStore
  tiposDoc: TiposDocStore

  constructor(
    private $element: JQLite,
    private $timeout: ITimeoutService,
    private $log: ILogService,
    private NotifService: NotificacionService,
    private AccesoDatos: AccesoDatos
  ) {}

  $onInit(): void {
    this.$log.info('[PanelDocNotificationsComponentCtrl] onInit')

    this._leerReglas()
  }

  private _leerReglas() {
    this.$loading = true

    this.AccesoDatos.Documentacion_CLIENT.reglasNotificacionDoc().then((reglasResponse) => {
      this.estados = reglasResponse.estados
      this.tiposDoc = new TiposDocStore(reglasResponse.tiposdocs)

      this.reglas = reglasResponse.reglas.map((r) => new ReglaNotifDoc(r, this.estados, this.tiposDoc))

      this.$loading = false

      this.$timeout(() => (this.$ready = true), 100)
    })
  }

  nuevaRegla() {
    this.reglas.push(new ReglaNotifDoc({} as IModelNotificacionDoc, this.estados, this.tiposDoc))
  }
}

angular.module('candidato').component('panelDocNotifications', {
  bindings: {
    // empresa: "<",
  },
  controller: PanelDocNotificationsComponentCtrl,
  // templateUrl: "panel-doc-notifications.component.html",
  template: require('./panel-doc-notifications.component.html'),
})

export class ReglaNotifDoc {
  mailsList: string[] = []

  constructor(public rule: IModelNotificacionDoc, private estados: IEstadoCvStore, private tiposDoc: TiposDocStore) {}

  actualiza(_rule: IModelNotificacionDoc) {
    this.rule = _rule
  }

  get estadosList() {
    return this.estados.list
  }

  get tiposDocGruposList() {
    return this.tiposDoc.gruposDocList()
  }

  mailsEnvioString() {
    var mails = split(this.rule.mail, /\;\\n/)

    return join(mails, '\n')
  }

  notifActiva() {
    return this.rule.activanotif
  }
}
